import * as React from 'react'

import { IntakeLayout } from '@app/layouts/intake'

import { routes } from './routes'

interface ScreenProps {
  children?: React.ReactNode
}

class IntakeScreen extends React.Component<ScreenProps> {
  render() {
    return <IntakeLayout routes={routes}>{this.props.children}</IntakeLayout>
  }
}

export default IntakeScreen
